<template>
  <div v-if="associate">
    <v-layout mt-4 flex-child>
      <v-tabs>
        <v-tab> <v-icon left>person</v-icon>Details </v-tab>
        <v-tab> <v-icon left>people_alt</v-icon>Assigned Customers </v-tab>
        <v-tab-item>
          <div>
            <v-layout mt-4 pt-4>
              <v-flex xs12 sm4>
                <v-layout wrap mt-4>
                  <v-flex xs12 pl-2 pr-2>
                    <v-text-field
                      :readonly="!canUpdateAssociate"
                      label="First Name*"
                      dense
                      outlined
                      v-model="updatedAssociate.firstName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 pl-2 pr-2>
                    <v-text-field
                      :readonly="!canUpdateAssociate"
                      label="Last Name*"
                      outlined
                      dense
                      v-model="updatedAssociate.lastName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 pl-2 pr-2>
                    <v-text-field
                      :readonly="!canUpdateAssociate"
                      label="Email*"
                      dense
                      outlined
                      v-model="updatedAssociate.email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 pl-2 pr-2>
                    <v-text-field
                      :readonly="!canUpdateAssociate"
                      label="Phone #*"
                      outlined
                      dense
                      v-model="updatedAssociate.phoneNumber"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 ml-2 pr-2>
                    <v-select
                      :readonly="!canUpdateAssociate"
                      v-model="updatedAssociate.roles[0]"
                      item-value="_id"
                      item-text="name"
                      :items="roles"
                      label="Role"
                      outlined
                      dense
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout pl-2 pb-4>
              <v-btn
                v-if="canUpdateAssociate"
                @click="saveAssociate"
                :disabled="!validAssociate"
                color="primary"
                >Save</v-btn
              >
            </v-layout>
          </div>
        </v-tab-item>
        <v-tab-item>
          <Table
            class="mt-4"
            :headers="customerHeaders"
            :items="assignedCustomers"
            :show-banner="false"
            icon="domain"
            :actions="customersTableActions"
            :items-per-page="20"
            :primaryActionText="canUpdateAssociate ? 'Assign Customer' : false"
            primaryActionIcon="add"
            @primary-action-event="prepAssignCustomerModal"
          />
        </v-tab-item>
      </v-tabs>
    </v-layout>

    <confirm-action-modal
      v-if="confirmActionModal"
      :text="
        `Are you sure you want to unassign ${selectedCustomer.name} from ${associate.firstName}?`
      "
      title="Unassign Customer"
      @confirm="unassignCustomer"
      :confirmActionModal.sync="confirmActionModal"
    />
    <assign-customer-modal
      v-if="assignCustomerModal"
      title="Assign customer to associate"
      :assignCustomerModal.sync="assignCustomerModal"
      :customers="unassignedCustomers"
      @save="assignNewCustomers"
    />
  </div>
</template>

<script>
import isValidEmail from "@/modules/isValidEmail";
import request from "@/modules/request";
import Table from "@/components/Table";
import { hasPermission } from "@/modules/rbac/permission-manifest";
import ConfirmActionModal from "@/components/shared/modals/ConfirmActionModal";
import AssignCustomerModal from "@/components/shared/modals/AssignCustomerModal";

export default {
  name: "Associate",
  inject: ["snackBar", "reactiveInjected"],
  components: { Table, ConfirmActionModal, AssignCustomerModal },
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      assignCustomerModal: false,
      selectedCustomer: {},
      confirmActionModal: false,
      roles: [],
      associate: {},
      customers: [],
      unassignedCustomers: [],
      assignedCustomers: [],
      customerHeaders: [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Phone #",
          value: "phoneNumber",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      customersTableActions: [],
      canReadCustomer: hasPermission(
        "canReadCustomer",
        null,
        this.reactiveInjected.activeUser
      ),
      canUpdateAssociate: hasPermission(
        "canUpdateAssociate",
        null,
        this.reactiveInjected.activeUser
      ),
    };
  },
  computed: {
    validAssociate() {
      return (
        this.associate.firstName &&
        this.associate.lastName &&
        this.associate.email &&
        isValidEmail(this.associate.email)
      );
    },
    updatedAssociate() {
      const { associate } = this;
      return associate;
    },
    open() {
      return this.isOpen;
    },
  },
  methods: {
    async assignNewCustomers(customers) {
      const proms = customers.map((customer) => {
        return new Promise((resolve, reject) => {
          const updatedAssignedReps = [
            ...customer.assignedReps,
            this.associate._id,
          ];
          request
            .callInternal({
              method: "patch",
              route: `/api/admin/company/${customer._id}`,
              data: {
                assignedReps: updatedAssignedReps,
              },
            })
            .then(() => {
              resolve();
            })
            .catch((error) => {
              console.error(error);
            });
        });
      });
      await Promise.all(proms).then(() => {
        this.snackBar(
          `Successfully assigned customers to ${this.associate.firstName}`,
          "success"
        );
        this.loadData();
      });

      this.assignCustomerModal = false;
    },
    prepAssignCustomerModal() {
      const { customers, assignedCustomers, associate } = this;
      this.unassignedCustomers = customers.filter((customer) => {
        const idx = assignedCustomers.findIndex(
          (cust) => cust._id === customer._id
        );
        if (idx === -1) return customer;
      });

      this.assignCustomerModal = true;
    },
    selectCustomer(customer) {
      this.selectedCustomer = customer;
      this.confirmActionModal = true;
    },
    async unassignCustomer() {
      const { selectedCustomer } = this;
      const { assignedReps } = selectedCustomer;
      const updatedAssignedReps = assignedReps.filter(
        (rep) => rep !== this.associate._id
      );

      await request
        .callInternal({
          method: "patch",
          route: `/api/admin/company/${selectedCustomer._id}`,
          data: {
            assignedReps: updatedAssignedReps,
          },
        })
        .then(() => {
          this.snackBar("Unassigned!", "success");
          this.loadData();
        })
        .catch((error) => {
          this.snackBar("Sorry, something went wrong", "error");
          console.error(error);
        });
      this.confirmActionModal = false;
    },
    setCustomersTableActions() {
      this.customersTableActions = [];
      if (this.canReadCustomer) {
        this.customersTableActions.push({
          color: "primary",
          click: this.viewCustomer,
          text: "View",
        });
      }

      if (this.canUpdateAssociate) {
        this.customersTableActions.push({
          color: "error",
          click: this.selectCustomer,
          text: "Unassign",
        });
      }
    },
    viewCustomer(customer) {
      this.$router.push({ name: "Customer", params: { id: customer._id } });
    },
    async saveAssociate() {
      const { associate } = this;
      await request
        .callInternal({
          method: "patch",
          route: `/api/admin/associates/${associate._id}`,
          data: associate,
        })
        .then(() => {
          this.snackBar("Associate saved!", "success");
        })
        .catch((error) => {
          this.snackBar("Sorry, something went wrong", "error");
          console.error(error);
        });
      this.editAssociateModal = false;
    },
    async getAssociate() {
      const { id } = this.$route.params;
      return request
        .callInternal({
          method: "get",
          route: `/api/admin/associate/${id}`,
        })
        .then((results) => {
          return results.data;
        });
    },
    async getCustomers() {
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/companies",
        })
        .then((results) => {
          return results.data;
        });
    },
    async getAssignedCustomers() {
      const { id } = this.$route.params;
      return request
        .callInternal({
          method: "get",
          route: `/api/admin/associate-customers/${id}`,
        })
        .then((results) => {
          return results.data;
        });
    },
    async loadData() {
      const {
        getRoles,
        getCustomers,
        getAssociate,
        getAssignedCustomers,
      } = this;
      const results = await Promise.all([
        getRoles("associate"),
        getCustomers(),
        getAssociate(),
        getAssignedCustomers(),
      ])
        .then((results) => {
          return results;
        })
        .catch((error) => {
          console.error(error);
        });

      const [roles, customers, associate, assignedCustomers] = results;
      Object.assign(this, {
        roles,
        customers,
        associate,
        assignedCustomers,
      });
      this.setCustomersTableActions();
      this.loading = false;
    },
    close() {
      this.$emit("update:editAssociateModal", false);
    },
    async getRoles(roleType) {
      return request
        .callInternal({
          method: "get",
          route: `/api/admin/roles?roleType=${roleType}`,
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
